/**
 * Cart API: section rendering, add-to-cart, quantity/remove.
 * Reads section id from [data-section-id] (hidden section in DOM). Replaces all [data-cart-content].
 * Load from head with defer.
 */
(function () {
  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root != null)
      ? String(window.Shopify.routes.root).replace(/\/$/, '')
      : '';
    return (root ? root + '/' : '/') + path.replace(/^\//, '');
  }

  function getSectionId() {
    var el = document.querySelector('[data-section-id]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  function getSectionContentAndFooter(htmlString) {
    if (!htmlString || typeof htmlString !== 'string') return { content: '', footer: '' };
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlString, 'text/html');
    var section = doc.querySelector('.shopify-section') || doc.querySelector('[id^="shopify-section-"]');
    if (!section) return { content: htmlString, footer: '' };
    var contentEl = section.querySelector('[data-cart-content]');
    var footerEl = section.querySelector('[data-cart-footer]');
    var cart = section.querySelector('.cart');
    return {
      content: contentEl ? contentEl.innerHTML : (cart ? cart.outerHTML : ''),
      footer: footerEl ? footerEl.innerHTML : ''
    };
  }

  function renderSections(parsed) {
    var sectionId = getSectionId();
    if (!parsed || !parsed.sections) return false;
    var sectionHtml = sectionId ? parsed.sections[sectionId] : null;
    if (sectionHtml == null) {
      var keys = Object.keys(parsed.sections);
      if (keys.length === 1) sectionHtml = parsed.sections[keys[0]];
    }
    if (sectionHtml == null) return false;
    var parts = getSectionContentAndFooter(sectionHtml);
    if (parts.content) {
      document.querySelectorAll('[data-cart-content]').forEach(function (container) {
        container.innerHTML = parts.content;
      });
    }
    if (parts.footer) {
      document.querySelectorAll('[data-cart-footer]').forEach(function (container) {
        container.innerHTML = parts.footer;
      });
    }
    return true;
  }

  function applyCartResponse(data) {
    if (renderSections(data)) return Promise.resolve(data);
    return refreshCartSection().then(function () { return data; });
  }

  function getClickTarget(e) {
    var target = e.target;
    if (target && target.nodeType !== 1) target = target.parentElement;
    return target || null;
  }

  function updateCounts(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var countStr = String(count);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = countStr; });
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = countStr; });
    var labelSource = document.querySelector('cart-drawer');
    var singular = (labelSource && labelSource.getAttribute('data-cart-label-singular')) || 'Product';
    var plural = (labelSource && labelSource.getAttribute('data-cart-label-plural')) || 'Products';
    var labelText = count === 1 ? singular : plural;
    document.querySelectorAll('[data-cart-label]').forEach(function (el) { el.textContent = labelText; });
  }

  function setLoading(loading) {
    document.querySelectorAll('[data-cart-content] .cart').forEach(function (cart) {
      cart.classList.toggle('cart--loading', !!loading);
    });
  }

  function setLineUpdating(item, updating) {
    if (!item) return;
    item.classList.toggle('cart__item--updating', !!updating);
    item.querySelectorAll('.cart__quantity-btn').forEach(function (btn) {
      btn.disabled = !!updating;
    });
  }

  function setLineRemoving(item, removing) {
    if (!item) return;
    item.classList.toggle('cart__item--removing', !!removing);
  }

  function getCartDrawerMessage(key) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    var attr = 'data-cart-' + key.replace(/_/g, '-');
    return drawer.getAttribute(attr);
  }

  function normalizeCartErrorMessage(err) {
    var msg = err && (err.message || err.description || (typeof err === 'string' ? err : ''));
    if (typeof msg !== 'string' || !msg) return null;
    var lower = msg.toLowerCase();
    if (lower.indexOf('maximum quantity') !== -1 || lower.indexOf('already in your cart') !== -1 ||
        lower.indexOf('quantité maximale') !== -1 || lower.indexOf('déjà dans votre panier') !== -1) {
      return getCartDrawerMessage('error_max_quantity') || msg;
    }
    if (lower.indexOf('out of stock') !== -1 || lower.indexOf('sold out') !== -1 || lower.indexOf('no longer available') !== -1 ||
        lower.indexOf('épuisé') !== -1 || lower.indexOf('rupture de stock') !== -1) {
      return getCartDrawerMessage('error_out_of_stock') || msg;
    }
    if (lower.indexOf('only') !== -1 && (lower.indexOf('available') !== -1 || lower.indexOf('left') !== -1)) {
      return getCartDrawerMessage('error_quantity_available') || msg;
    }
    if (lower.indexOf('seulement') !== -1 && lower.indexOf('disponibil') !== -1) {
      return getCartDrawerMessage('error_quantity_available') || msg;
    }
    return msg;
  }

  function showCartError(message) {
    var normalized = normalizeCartErrorMessage(message);
    var fallbackEl = document.querySelector('cart-drawer');
    var fallback = (fallbackEl && fallbackEl.getAttribute('data-cart-error-fallback')) || 'An error occurred. Please try again.';
    var text = normalized || (message && (message.message || message.description || message)) || fallback;
    if (typeof text !== 'string') text = fallback;
    document.querySelectorAll('[data-cart-error]').forEach(function (el) {
      el.textContent = text;
      el.hidden = false;
    });
    if (window.clearCartErrorTimer) clearTimeout(window.clearCartErrorTimer);
    window.clearCartErrorTimer = setTimeout(function () {
      document.querySelectorAll('[data-cart-error]').forEach(function (el) {
        el.textContent = '';
        el.hidden = true;
      });
      window.clearCartErrorTimer = null;
    }, 5000);
  }

  function parseFetchJson(res) {
    return res.text().then(function (text) {
      var data;
      try {
        data = text ? JSON.parse(text) : {};
      } catch (e) {
        var fallback = getCartDrawerMessage('error') ||
          'Could not update cart. Please try again.';
        throw { message: fallback, description: fallback };
      }
      if (!res.ok) throw data;
      return data;
    });
  }

  function getFormQuantity(form) {
    var selected = form.querySelector('.quantity-options input[name="quantity"]:checked:not(:disabled)');
    if (selected) return parseInt(selected.value, 10) || 1;
    var qtyEl = form.elements && form.elements['quantity'];
    if (qtyEl && qtyEl.value != null && !qtyEl.disabled) return parseInt(qtyEl.value, 10) || 1;
    return 1;
  }

  function dispatchCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart || {} }));
  }

  function syncCartState(cart) {
    if (cart && typeof cart.item_count === 'number') {
      updateCounts(cart);
      dispatchCartUpdated(cart);
      return Promise.resolve(cart);
    }
    return fetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' }
    }).then(parseFetchJson).then(function (freshCart) {
      updateCounts(freshCart);
      dispatchCartUpdated(freshCart);
      return freshCart;
    });
  }

  function addToCart(form) {
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? parseInt(idInput.value, 10) : null;
    var qty = getFormQuantity(form);
    if (!id || isNaN(id)) return Promise.reject(new Error('Missing or invalid variant id'));
    var sectionId = getSectionId();
    if (!sectionId) return Promise.reject(new Error('No section id'));
    var requestedQty = isNaN(qty) ? 1 : Math.max(1, Math.min(999, qty));
    var payload = {
      items: [{ id: id, quantity: requestedQty }],
      sections: sectionId,
      sections_url: window.location.pathname
    };
    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(parseFetchJson);
  }

  function changeLine(line, quantity) {
    var sectionId = getSectionId();
    if (!sectionId) return Promise.reject(new Error('No section id'));
    var payload = {
      line: parseInt(line, 10),
      quantity: parseInt(quantity, 10),
      sections: sectionId,
      sections_url: window.location.pathname
    };
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(parseFetchJson);
  }

  function refreshCartSection() {
    var sectionId = getSectionId();
    if (!sectionId) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root != null)
      ? String(window.Shopify.routes.root).replace(/\/$/, '')
      : '';
    var sectionUrl = (root ? root + '/' : '/') + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(sectionUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parts = getSectionContentAndFooter(html);
        if (parts.content) {
          document.querySelectorAll('[data-cart-content]').forEach(function (container) {
            container.innerHTML = parts.content;
          });
        }
        if (parts.footer) {
          document.querySelectorAll('[data-cart-footer]').forEach(function (container) {
            container.innerHTML = parts.footer;
          });
        }
      });
  }

  function setAddToCartButtonState(btn, state, errorMessage) {
    if (!btn) return;
    var labelTarget = btn.querySelector('.add-to-cart-label') || btn.querySelector('.mono.extra-small-font-size') || btn;
    var defaultLabel = btn.getAttribute('data-add-to-cart-label') || 'Add to cart';
    var addingLabel = btn.getAttribute('data-adding-label') || 'Adding…';
    var addedLabel = btn.getAttribute('data-added-label') || 'Added!';
    if (state === 'adding') {
      labelTarget.textContent = addingLabel;
    } else if (state === 'added') {
      labelTarget.textContent = addedLabel;
    } else if (state === 'error' && typeof errorMessage === 'string') {
      labelTarget.textContent = errorMessage;
    } else {
      labelTarget.textContent = defaultLabel;
    }
  }

  function handleAddSubmit(e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn && (btn.disabled || btn.classList.contains('sold-out'))) return;
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      setAddToCartButtonState(btn, 'adding');
    }
    setLoading(true);
    addToCart(form)
      .then(applyCartResponse)
      .then(syncCartState)
      .then(function () {
        setAddToCartButtonState(btn, 'added');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        if (window.addToCartFeedbackTimer) clearTimeout(window.addToCartFeedbackTimer);
        window.addToCartFeedbackTimer = setTimeout(function () {
          setAddToCartButtonState(btn, 'default');
          window.addToCartFeedbackTimer = null;
        }, 2000);
      })
      .catch(function (err) {
        if (console && console.error) console.error('Cart add error', err);
        showCartError(err);
        var message = normalizeCartErrorMessage(err) || (err && (err.message || err.description)) || 'An error occurred.';
        setAddToCartButtonState(btn, 'error', message);
        if (window.addToCartFeedbackTimer) clearTimeout(window.addToCartFeedbackTimer);
        window.addToCartFeedbackTimer = null;
      })
      .then(function () {
        setLoading(false);
        if (btn) {
          btn.removeAttribute('aria-busy');
          if (!btn.classList.contains('sold-out')) {
            btn.disabled = false;
          }
        }
      });
  }

  function handleCartContentClick(e) {
    var target = getClickTarget(e);
    if (!target) return;

    var content = target.closest('[data-cart-content]');
    if (!content) return;

    var isRemove = target.closest('[data-cart-remove]');
    if (isRemove) {
      e.preventDefault();
      var removeItem = target.closest('.cart__item');
      var removeLine = removeItem ? removeItem.getAttribute('data-line') : null;
      if (!removeLine) return;
      setLineRemoving(removeItem, true);
      changeLine(removeLine, 0)
        .then(applyCartResponse)
        .then(syncCartState)
        .catch(function (err) {
          if (console && console.error) console.error('Cart remove error', err);
          showCartError(err);
          setLineRemoving(removeItem, false);
        });
      return;
    }

    var item = target.closest('.cart__item');
    var line = item ? item.getAttribute('data-line') : null;
    if (!line) return;

    var minus = target.closest('.cart__quantity-btn--minus');
    var plus = target.closest('.cart__quantity-btn--plus');
    var qtyEl = item ? item.querySelector('.cart__quantity-value') : null;
    if (!qtyEl) return;
    var current = parseInt(qtyEl.textContent, 10) || 0;
    var next = current;
    if (minus) next = Math.max(0, current - 1);
    else if (plus) next = current + 1;
    else return;
    e.preventDefault();
    qtyEl.textContent = next;
    setLineUpdating(item, true);
    changeLine(line, next)
      .then(applyCartResponse)
      .then(syncCartState)
      .catch(function (err) {
        if (console && console.error) console.error('Cart change error', err);
        showCartError(err);
        qtyEl.textContent = current;
        setLineUpdating(item, false);
      })
      .then(function () {
        setLineUpdating(item, false);
      });
  }

  document.addEventListener('submit', handleAddSubmit);
  document.addEventListener('click', handleCartContentClick);
})();
